import { getIn } from 'formik';

interface IFormBuilderActions {
	[key: string]: any;
}

const actions: IFormBuilderActions = {
	setValue: ({ action, formValues, setFieldValue }: any) => {
		const sets = action.data && action.data.sets ? action.data.sets : [];

		sets.forEach((set: any) => {
			const otherFieldValue = getIn(formValues, set.path);
			const overrideExistingValue =
				typeof set.overrideExistingValue === 'boolean'
					? set.overrideExistingValue
					: true;

			let setValue = set.value;
			if (set.value === undefined && set.valuePath) {
				setValue = getIn(formValues, set.valuePath);
			}

			if (
				overrideExistingValue ||
				otherFieldValue === '' ||
				otherFieldValue === null ||
				typeof otherFieldValue === 'undefined'
			) {
				if (set.computedValue) {
					setTimeout(() => {
						setFieldValue(set.path, set.computedValue(setValue));
					});
				} else {
					setTimeout(() => {
						setFieldValue(set.path, setValue);
					});
				}
			}
		});
	},
	call: ({ action, fieldValue }: any) => {
		setTimeout(() => {
			action.functionName(fieldValue);
		});
	},
	processData: ({ action, formValues }: any) => {
		const { data } = action;
		if (data.processHandler) {
			data.processHandler(formValues);
		}
	},
	cleanupInput: ({ action, formValues, setFieldValue }: any) => {
		const { data } = action;
		const rawValue = getIn(formValues, data.path);
		if (typeof rawValue === 'number' || typeof rawValue === 'string') {
			// convert to string and strip all matching pattern
			const formattedValue = String(rawValue).replace(
				data.patter,
				data.newSubstr ?? '',
			);

			setTimeout(() => {
				setFieldValue(data.path, formattedValue);
			});
		}
	},
};

export default actions;
